<template>
  <b-form-checkbox v-model="value" :value="this.trueString" :unchecked-value="this.falseString" :disabled="this.disabled" @change="change($event)">{{this.label}}</b-form-checkbox>
</template>
<script type="text/javascript">
/* eslint-disable */
import Vue from 'vue'

export default {
  name: 'FITCheckbox',
  props: {
    label: String,
    trueString: String,
    falseString: String,
    disabled: Boolean,
    value: [Boolean,String],
   },
  data() {
    return {

    }
  },
  created(){
    // if(this.initValue){
    //   this.value = this.initValue
    // }
  },
  methods:{
    change(event){
      this.$emit('input', event);
    }
  }
}

</script>
<style type="text/css">
.custom-checkbox .custom-control-input:checked~.custom-control-label::before {
  background-color: #007bff;
}

</style>



// WEBPACK FOOTER //
// src/components/Form/FITCheckbox.vue